module.exports = __webpack_public_path__ + "static/media/Victor.d7b4dbbe.pdf";